import { useApolloClient } from "@apollo/client";
import { ShiftIdWithJobId } from "@sinch/core/entities/fragments.graphql";
import { ShiftIdWithJobIdFragment } from "@sinch/core/entities/fragments.types";

export const useShiftLinks = () => {
  const client = useApolloClient();

  const getDetailLink = (shiftId: string) => {
    const shiftIdWithJobId = client.readFragment<ShiftIdWithJobIdFragment>({
      id: `Shift:${shiftId}`,
      fragment: ShiftIdWithJobId,
    });

    if (shiftIdWithJobId?.job?.id && shiftIdWithJobId?.id) {
      return decodeURI(`/admin/jobs/view/${shiftIdWithJobId.job?.id}#S${shiftIdWithJobId.id}`);
    }
    return null;
  };

  const getEditLink = (shiftId: string) => {
    const shiftIdWithJobId = client.readFragment<ShiftIdWithJobIdFragment>({
      id: `Shift:${shiftId}`,
      fragment: ShiftIdWithJobId,
    });

    if (shiftIdWithJobId?.job?.id && shiftIdWithJobId?.id) {
      return decodeURI(
        `/admin/jobs/builder/${shiftIdWithJobId.job?.id}#S${shiftIdWithJobId.id}`
      );
    }
    return null;
  };
  return { getDetailLink, getEditLink };
};
